'use client';

import { c as _c } from "react/compiler-runtime";
import type { LiveItem } from '@module/apis/client-side/live/type';
import MainTitle from '@pc/components/atoms/typograph/MainTitle';
import BroadcastList from '@pc/components/molecules/broadcast/BroadcastList';
import BroadcastListSkeleton from '@pc/components/molecules/broadcast/BroadcastListSkeleton';
import type { ReactNode } from 'react';
interface Props {
  dataTestId: string;
  title: string;
  list?: LiveItem[];
  isLoading: boolean;
  isFetching: boolean;
  isFetched: boolean;
  listLength: 12 | 15;
  titleAction?: ReactNode;
  description?: ReactNode;
  icon?: string;
}
export interface MainSectionProps {
  isLoading: boolean;
  isFetching: boolean;
  isFetched: boolean;
  currentScreenSize: 'md' | 'lg' | 'xl';
  listLength: 12 | 15;
}
function MainBroadcastSection(t0) {
  const $ = _c(13);
  const {
    dataTestId,
    title,
    list,
    isLoading,
    isFetching,
    isFetched,
    listLength,
    titleAction,
    description,
    icon
  } = t0;
  if (isFetched && !list?.length) {
    return null;
  }
  const shouldShowSkeleton = isLoading || isFetching || list === undefined;
  let t1;
  if ($[0] !== description || $[1] !== icon || $[2] !== title || $[3] !== titleAction) {
    t1 = titleAction ? <div className="mb-6 flex items-center gap-[20px]">{icon && <img src={icon} alt="icon" width={17} height={24} className="mr-[8px]" />}<MainTitle className="mb-0">{title}</MainTitle>{titleAction}{description}</div> : <div className="mb-6 flex items-center">{icon && <img src={icon} alt="icon" width={17} height={24} className="mr-[8px]" />}<MainTitle className="mr-[20px] mb-0">{title}</MainTitle>{description}</div>;
    $[0] = description;
    $[1] = icon;
    $[2] = title;
    $[3] = titleAction;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== list || $[6] !== listLength || $[7] !== shouldShowSkeleton) {
    t2 = shouldShowSkeleton ? <BroadcastListSkeleton itemLength={listLength} /> : <BroadcastList list={list} />;
    $[5] = list;
    $[6] = listLength;
    $[7] = shouldShowSkeleton;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== dataTestId || $[10] !== t1 || $[11] !== t2) {
    t3 = <div className="mb-10" data-testid={dataTestId}>{t1}{t2}</div>;
    $[9] = dataTestId;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
export default MainBroadcastSection;